import { render, staticRenderFns } from "./WordpressIntegration.pug?vue&type=template&id=c19e92b0&lang=pug&external"
import script from "./WordpressIntegration.js?vue&type=script&lang=js&external"
export * from "./WordpressIntegration.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports